import { render, staticRenderFns } from "./resumeInfo.vue?vue&type=template&id=8b36aa62&scoped=true"
import script from "./resumeInfo.vue?vue&type=script&lang=js"
export * from "./resumeInfo.vue?vue&type=script&lang=js"
import style0 from "./resumeInfo.vue?vue&type=style&index=0&id=8b36aa62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b36aa62",
  null
  
)

export default component.exports